/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface InvolvementProfileConfig {
  profile: InvolvementProfileConfigProfileEnum
  label: string
}

export const InvolvementProfileConfigProfileEnum = {
  NO_INVOLVEMENT: "NO_INVOLVEMENT",
  EMPLOYER: "EMPLOYER",
  TERRITORIAL: "TERRITORIAL",
  SOCIAL: "SOCIAL",
  ECOLO: "ECOLO",
  ETHICS: "ETHICS",
  OTHER: "OTHER",
  MULTI_COMMITTED: "MULTI_COMMITTED"
} as const

export type InvolvementProfileConfigProfileEnum =
  (typeof InvolvementProfileConfigProfileEnum)[keyof typeof InvolvementProfileConfigProfileEnum]
